import React from "react";
import PropTypes from "prop-types";

const CustomRow = ({ header, value }) => {
  return (
    <div className="sub-row">
      <div className="row-column -header">
        <div>{header}</div>
      </div>
      <div className="row-column">
        <div> {value}</div>
      </div>
    </div>
  );
};
CustomRow.propTypes = {
  header: PropTypes.string,
  value: PropTypes.string
};
export default CustomRow;
